((Drupal, once) => {
  const HIDE_LEAD_PX = 80;
  Drupal.behaviors.accioncontraelhambreViewSearchStickyTextbox = {
    attach(context) {
      once(
        'accioncontraelhambre-view-search-sticky-textbox',
        '.position-sticky-sentinel',
        context,
      ).forEach((sentinel) => {
        const observer = new IntersectionObserver(
          ([entry]) => {
            const sticky = sentinel.nextElementSibling;
            const textboxRow = sticky
              ? sticky.querySelector('.view-search-textbox-row')
              : null;
            if (textboxRow) {
              textboxRow.classList.toggle('is-sticky-pinned', !entry.isIntersecting);
            }
          },
          { threshold: 0, rootMargin: `-${HIDE_LEAD_PX}px 0px 0px 0px` },
        );
        observer.observe(sentinel);
      });
    },
  };
})(Drupal, once);
